// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {RootState} from '../store/store';
import AuthProvider from '../../AuthProviders/OIDCProvider';

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_BACKEND_HOST + '/',
        prepareHeaders: async (headers, {getState}) => {
            // By default, if we have a token in the store, let's use that for authenticated requests
            const token = await AuthProvider.getToken();
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: 120,
    endpoints: () => ({}),
});
